import { __decorate } from "tslib";
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import lang from '@blade/common/pages/alarm-center-dialog/lang/index';
import alarmTimeLine from '@blade/common/pages/alarm-center-dialog/components/alarm-time-line.vue';
import detailsLeft from '@blade/common/pages/alert-details/components/details-left.vue';
import detailsRight from '@blade/common/pages/alert-details/components/details-right.vue';
import { AlarmDetailsModule } from '@blade/common/store/alarm-details';
import { getAlarmList } from '@blade/common/api/alarm-center';
import moment from 'moment';
let alertDetails = class alertDetails extends Vue {
    isSelf;
    dialogTableVisible = true;
    timeLineParam = {
        taskIds: [],
        deviceIds: [],
        curTime: '',
    };
    newReqParam = {
        taskIds: [],
        deviceIds: [],
        dateEnd: '',
        dateStart: '',
        page: 1,
        incidentTypes: [],
    };
    lists = [];
    details = null;
    listIdx = [0, 0];
    detailId = '';
    isDelete = false;
    get oldDetails() {
        return AlarmDetailsModule.detailsData;
    }
    get leftInhibit() {
        return AlarmDetailsModule.leftInhibit;
    }
    get rightInhibit() {
        return AlarmDetailsModule.rightInhibit;
    }
    get reqParam() {
        return AlarmDetailsModule.paramTaskIds;
    }
    // 下标
    get oldListIdx() {
        return AlarmDetailsModule.listIdx;
    }
    onDetails(val) {
        this.details = val;
        this.detailId = val?.id || '';
    }
    // 请求参数
    onReqParam(val) {
        if (val) {
            this.newReqParam = val;
        }
    }
    closeDialog() {
        this.$emit('closeDialog');
    }
    upadtedelStatus(val) {
        this.isDelete = val;
    }
    async updateDetail() {
        const id = this.details?.id;
        let parms = {
            page: 1,
            size: 100,
            dateEnd: '',
            dateStart: '',
            keyWord: '',
            alertLevel: null,
            deviceIds: [],
            incidentStatus: null,
            incidentTypes: null,
            favorite: null,
            recordIds: [id],
        };
        const list = await getAlarmList({ ...parms });
        const details = list?.list?.[0] ?? null;
        AlarmDetailsModule.updateDetailsData(details);
    }
    confirmDialog(status) {
        if (status === 'NO_REPORT' && this.details) {
            this.details.incidentStatus = 'IGNORED';
            AlarmDetailsModule.updateDetailsData(this.details);
            this.getDataAgain();
        }
        else if (status === 'VERIFIED' && this.details) {
            this.details.incidentStatus = 'SOLVED';
            AlarmDetailsModule.updateDetailsData(this.details);
            this.getDataAgain();
        }
        else if (status === 'DELETE' && this.details) {
            this.isDelete = true;
            let total = AlarmDetailsModule.total;
            let arr = AlarmDetailsModule.alarNOChange;
            for (let i = 0; i < arr.length; i++) {
                if (arr[i].id === this.details.id) {
                    arr.splice(i, 1);
                    i--;
                }
            }
            total -= 1;
            AlarmDetailsModule.updatAalarNOChange(arr);
            AlarmDetailsModule.updateTotal(total);
            this.initTimeData(arr);
        }
        else {
            // this.updateDetail();
            this.getDataAgain();
        }
        if (this.isSelf !== 'self' && status !== 'remarks') {
            this.closeDialog();
        }
    }
    async getDataAgain() {
        this.newReqParam.page = 1;
        AlarmDetailsModule.updateParamTaskIds(this.newReqParam);
        const list = await AlarmDetailsModule.getAlarmListFun(this.newReqParam);
        if (!list?.list?.length) {
            this.closeDialog();
            return;
        }
        AlarmDetailsModule.updatAalarNOChange(list.list);
        this.initTimeData(list.list);
    }
    async previousDetail(event) {
        let obj = {
            type: 'pre',
            idx1: this.oldListIdx[0],
            idx2: this.oldListIdx[1] - 1,
        };
        this.isDelete = true;
        AlarmDetailsModule.updateListIdxs(obj);
        const list = await AlarmDetailsModule.getAlarmListFun(this.newReqParam);
        AlarmDetailsModule.updatAalarNOChange(list.list);
        this.initTimeData(list.list);
    }
    async nextDetail() {
        let obj = {
            type: 'next',
            idx1: this.oldListIdx[0],
            idx2: this.oldListIdx[1] + 1,
        };
        this.isDelete = true;
        AlarmDetailsModule.updateListIdxs(obj);
        const list = await AlarmDetailsModule.getAlarmListFun(this.newReqParam);
        AlarmDetailsModule.updatAalarNOChange(list.list);
        this.initTimeData(list.list);
    }
    initTimeData(data, first) {
        let timeaArr = [];
        const b = data.reduce((prev, cur) => {
            if (!prev[this.timeDateFormat(cur.alertTime)]) {
                prev[this.timeDateFormat(cur.alertTime)] = [];
            }
            prev[this.timeDateFormat(cur.alertTime)].push(cur);
            return prev;
        }, {});
        for (let i in b) {
            timeaArr.push({
                timeTitle: i,
                lists: b[i],
            });
        }
        this.lists = timeaArr;
        AlarmDetailsModule.updateAlarConList(timeaArr);
        AlarmDetailsModule.updateDetailsData(this.lists?.[0]?.lists?.[0] ?? null);
    }
    timeDateFormat(time) {
        return moment(Number(time)).format('MM-DD');
    }
};
__decorate([
    Prop()
], alertDetails.prototype, "isSelf", void 0);
__decorate([
    Watch('oldDetails', { deep: true, immediate: true })
], alertDetails.prototype, "onDetails", null);
__decorate([
    Watch('reqParam', { deep: true, immediate: true })
], alertDetails.prototype, "onReqParam", null);
alertDetails = __decorate([
    Component({
        name: 'alertDetails',
        components: { alarmTimeLine, detailsRight, detailsLeft },
        i18n: {
            messages: lang,
        },
    })
], alertDetails);
export default alertDetails;
